import React from "react";

import {
  FaArrowRight,
} from "react-icons/fa";

import "../styles/AboutUsSection.css";

const AboutUsSection = () => {

  return (

    <section className="about-section">

      <div className="about-container">

        {/* LEFT IMAGE */}

        <div className="about-image">

          <img
            src="https://i.ibb.co/C5BxXST8/aboutussection.png"
            alt="SAC MTB Premium Rides"
          />

          <div className="about-image-overlay">

            <span>
              SAC MTB
            </span>

            <h3>
              Ride Beyond Limits
            </h3>

          </div>

        </div>

        {/* RIGHT CONTENT */}

        <div className="about-content">

          <span className="about-tag">
            OUR STORY
          </span>

          <h2 className="about-title">

            Built For
            <br />

            Adventure &
            <br />

            Joy.

          </h2>

          <p className="about-text">

            From premium mountain bicycles
            to luxury ride-on toys for kids,
            every SAC MTB product is designed
            to create excitement, confidence,
            and unforgettable memories.

          </p>

          <p className="about-text">

            Whether it’s conquering trails,
            exploring the streets, or giving
            children their first driving experience,
            we build rides that combine style,
            safety, durability, and emotion.

          </p>

          <p className="about-text">

            At
            <strong className="Sacmtb">
              {" "}SAC MTB{" "}
            </strong>

            we believe every ride should feel premium,
            thrilling, and full of life.

          </p>

          {/* STATS */}

          <div className="about-stats">

            <div className="about-stat">

              <h4>
                10K+
              </h4>

              <p>
                Happy Riders
              </p>

            </div>

            <div className="about-stat">

              <h4>
                50+
              </h4>

              <p>
                Cities Served
              </p>

            </div>

            <div className="about-stat">

              <h4>
                4.8★
              </h4>

              <p>
                Customer Rating
              </p>

            </div>

          </div>

          {/* BUTTON */}

          <button className="about-btn">

            Discover More

            <FaArrowRight />

          </button>

        </div>

      </div>

    </section>
  );
};

export default AboutUsSection;